<template>
  <div>
    <a>
      <save-icon icon-name="Save Activity"></save-icon>
    </a>
  </div>
</template>

<script>
import SaveIcon from 'components/icons/SaveIcon.vue';

export default {
  components: {
    SaveIcon
  }
};
</script>

<style lang="scss" scoped>
.save-activity-button-container {
  position: fixed;
  top: 5px;
  left: 5px;
  margin: 10px 8px;
  z-index: 1000;
}
</style>
